import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.handleRetry = () => {
            this.setState({ hasError: false, error: null });
        };
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return (_jsx("div", { className: "flex items-center justify-center min-h-screen p-4", children: _jsxs(Card, { className: "w-full max-w-md border-destructive", children: [_jsx(CardHeader, { children: _jsx(CardTitle, { className: "flex items-center gap-2 text-destructive", children: _jsx("span", { children: "Page temporarily unavailable" }) }) }), _jsxs(CardContent, { className: "space-y-4", children: [_jsx("p", { className: "text-sm text-muted-foreground", children: _jsx("span", { children: "We could not load this page. Please try again." }) }), _jsx(Button, { onClick: this.handleRetry, className: "w-full", variant: "default", children: _jsx("span", { children: "Try again" }) })] })] }) }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
